import {
    ProductDetailTabSection,
    ProductDetailTabTable,
    emptyProductDetailColumns,
    type ProductDetailTabProps
} from "@/views/pages/productManagement/ProductDetailTabPrimitives";

export type deliveryTableProps = ProductDetailTabProps;

/** goodsManagement / components / delivery / deliveryTable：保留数据展示、编辑提交和父级事件回调。 */
export default function MigrationComponent(props: deliveryTableProps) {
    return (
        <ProductDetailTabSection title="提货明细" className="delivery-table">
            <ProductDetailTabTable
                ariaLabel="提货明细"
                columns={emptyProductDetailColumns(["提货编号", "提货日期", "结算金额", "提货吨位（吨）", "状态", "操作"])}
                data={props.items}
            />
            {props.children}
        </ProductDetailTabSection>
    );
}
